import { InspectionCase } from './inspection-case.dto';

export class InspectionVolumeCaseDto extends InspectionCase {
  length?: number;
  width?: number;
  depth?: number;
}
export class InspectionVolumeCase extends InspectionVolumeCaseDto {
  get volume(): string {
    return (this.length * this.width * this.depth).toFixed(2);
  }

  constructor(
    data: InspectionVolumeCaseDto = { isApplicable: true, isPassed: true }
  ) {
    super(data);
    this.length = data.length || 0;
    this.width = data.width || 0;
    this.depth = data.depth || 0;
  }
}
